var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_74",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 83
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.431641,
    y: 0.0372314,
    width: 82.819,
    height: 82.819,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4573 52.8344L53.2289 41.4467L35.4573 30.0591V52.8344ZM41.8559 71.4686C37.7052 71.4686 33.802 70.681 30.1465 69.1057C26.491 67.5304 23.3113 65.3924 20.6076 62.6916C17.9034 59.9907 15.7627 56.8151 14.1857 53.1648C12.6081 49.5138 11.8193 45.6127 11.8193 41.4614C11.8193 37.3107 12.607 33.4076 14.1823 29.752C15.7576 26.0965 17.8956 22.9169 20.5964 20.2132C23.2972 17.5089 26.4728 15.3682 30.1232 13.7912C33.7741 12.2136 37.6753 11.4249 41.8266 11.4249C45.9773 11.4249 49.8804 12.2125 53.536 13.7878C57.1915 15.3631 60.3711 17.5011 63.0748 20.2019C65.7791 22.9028 67.9197 26.0784 69.4968 29.7287C71.0743 33.3797 71.8631 37.2808 71.8631 41.4321C71.8631 45.5828 71.0755 49.4859 69.5002 53.1415C67.9249 56.797 65.7869 59.9766 63.086 62.6803C60.3852 65.3846 57.2096 67.5253 53.5593 69.1023C49.9083 70.6799 46.0072 71.4686 41.8559 71.4686ZM41.8412 69.0531C49.548 69.0531 56.0758 66.3787 61.4245 61.03C66.7732 55.6813 69.4476 49.1535 69.4476 41.4467C69.4476 33.74 66.7732 27.2122 61.4245 21.8635C56.0758 16.5148 49.548 13.8404 41.8412 13.8404C34.1345 13.8404 27.6067 16.5148 22.258 21.8635C16.9093 27.2122 14.2349 33.74 14.2349 41.4467C14.2349 49.1535 16.9093 55.6813 22.258 61.03C27.6067 66.3787 34.1345 69.0531 41.8412 69.0531Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerIcon);
export default __webpack_public_path__ + "static/media/playerIcon.4c28c905da29c203396c159e084fb623.svg";
export { ForwardRef as ReactComponent };